// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snack-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.snack-container .info {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.snack-container .info p,
.snack-container .info span {
  color: #000000;
}
.snack-container .info span {
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 18.75px !important;
}
.snack-container .info p {
  margin: 0px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 16.41px !important;
}

mat-icon {
  width: 30px !important;
  height: 30px !important;
  font-size: 30px !important;
}

.icon-error {
  color: #de0202 !important;
}

.icon-warn {
  color: #dab90e !important;
}

.icon-success {
  color: #2bcc10 !important;
}

.icon-info {
  color: #1d93ff !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNuYWNrYmFyLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsOEJBQUE7RUFDQSxTQUFBO0FBQ0Y7QUFBRTtFQUNFLGFBQUE7RUFDQSxzQkFBQTtFQUNBLGdCQUFBO0FBRUo7QUFESTs7RUFFRSxjQUFBO0FBR047QUFESTtFQUNFLDBCQUFBO0VBQ0EsMkJBQUE7RUFDQSwrQkFBQTtBQUdOO0FBREk7RUFDRSxzQkFBQTtFQUNBLDBCQUFBO0VBQ0EsMkJBQUE7RUFDQSwrQkFBQTtBQUdOOztBQUVBO0VBQ0Usc0JBQUE7RUFDQSx1QkFBQTtFQUNBLDBCQUFBO0FBQ0Y7O0FBQ0E7RUFDRSx5QkFBQTtBQUVGOztBQUNBO0VBQ0UseUJBQUE7QUFFRjs7QUFDQTtFQUNFLHlCQUFBO0FBRUY7O0FBQ0E7RUFDRSx5QkFBQTtBQUVGIiwiZmlsZSI6InNuYWNrYmFyLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNuYWNrLWNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgZ2FwOiAxMHB4O1xuICAuaW5mbyB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgcCxcbiAgICBzcGFuIHtcbiAgICAgIGNvbG9yOiAjMDAwMDAwO1xuICAgIH1cbiAgICBzcGFuIHtcbiAgICAgIGZvbnQtc2l6ZTogMTZweCAhaW1wb3J0YW50O1xuICAgICAgZm9udC13ZWlnaHQ6IDUwMCAhaW1wb3J0YW50O1xuICAgICAgbGluZS1oZWlnaHQ6IDE4Ljc1cHggIWltcG9ydGFudDtcbiAgICB9XG4gICAgcCB7XG4gICAgICBtYXJnaW46IDBweCAhaW1wb3J0YW50O1xuICAgICAgZm9udC1zaXplOiAxNHB4ICFpbXBvcnRhbnQ7XG4gICAgICBmb250LXdlaWdodDogNDAwICFpbXBvcnRhbnQ7XG4gICAgICBsaW5lLWhlaWdodDogMTYuNDFweCAhaW1wb3J0YW50O1xuICAgIH1cbiAgfVxufVxuXG5tYXQtaWNvbiB7XG4gIHdpZHRoOiAzMHB4ICFpbXBvcnRhbnQ7XG4gIGhlaWdodDogMzBweCAhaW1wb3J0YW50O1xuICBmb250LXNpemU6IDMwcHggIWltcG9ydGFudDtcbn1cbi5pY29uLWVycm9yIHtcbiAgY29sb3I6ICNkZTAyMDIgIWltcG9ydGFudDtcbn1cblxuLmljb24td2FybiB7XG4gIGNvbG9yOiAjZGFiOTBlICFpbXBvcnRhbnQ7XG59XG5cbi5pY29uLXN1Y2Nlc3Mge1xuICBjb2xvcjogIzJiY2MxMCAhaW1wb3J0YW50O1xufVxuXG4uaWNvbi1pbmZvIHtcbiAgY29sb3I6ICMxZDkzZmYgIWltcG9ydGFudDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/basic/snackbar/snackbar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAEJ;AADI;;EAEE,cAAA;AAGN;AADI;EACE,0BAAA;EACA,2BAAA;EACA,+BAAA;AAGN;AADI;EACE,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,+BAAA;AAGN;;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;AACA,gxDAAgxD","sourcesContent":[".snack-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  .info {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    p,\n    span {\n      color: #000000;\n    }\n    span {\n      font-size: 16px !important;\n      font-weight: 500 !important;\n      line-height: 18.75px !important;\n    }\n    p {\n      margin: 0px !important;\n      font-size: 14px !important;\n      font-weight: 400 !important;\n      line-height: 16.41px !important;\n    }\n  }\n}\n\nmat-icon {\n  width: 30px !important;\n  height: 30px !important;\n  font-size: 30px !important;\n}\n.icon-error {\n  color: #de0202 !important;\n}\n\n.icon-warn {\n  color: #dab90e !important;\n}\n\n.icon-success {\n  color: #2bcc10 !important;\n}\n\n.icon-info {\n  color: #1d93ff !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
